<style>
  .Text {
    display:block; position:absolute; overflow:visible;
    margin:0px; padding:0px; border:none; border-radius:0px;
    font-size:14px;
  }
</style>

<div {...$$restProps} class:Text={true}>
  <slot></slot>
</div>
